export default {"src":"/_next/static/media/arrow_loop.ec51d0ee.svg","height":68,"width":56,"blurWidth":0,"blurHeight":0};